import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ChecklistItem, ChecklistItemFilter, PageResponse } from '@app/models';
import * as _ from 'lodash';
import { Observable } from 'rxjs';
import { BaseServiceClass } from '../baseService.service';
import { environment } from 'environments/environment';

@Injectable({ providedIn: 'root' })
export class ChecklistItemServiceV2 extends BaseServiceClass<ChecklistItem> {
  entity_url: any;

  constructor(protected httpService: HttpClient) {
    super(httpService, '/itenschecklists');
  }

  public updateItemsChecklist(params: any): Observable<any> {
    let arrayClone = params.map(item => ({ ...item }));
    let filteredArray = arrayClone.map(obj => _.omitBy(obj, _.isNil));
    return this.httpService.patch(`${this.entity_url}/batch`, filteredArray);
  }

  filterWithChecklist(
    checklistItemFilter: ChecklistItemFilter,
    checklistId: number
  ) {
    if (!checklistItemFilter.linesPerPage) {
      checklistItemFilter.linesPerPage = 500;
    }

    let options = { params: <any>checklistItemFilter };
    return this.httpService.get<PageResponse<ChecklistItem>>(
      `${environment.apiUrl}/api/v2/checklist-items/checklists/${checklistId}/filter`,
      options
    );
  }
}
